"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SRAdvancedSettingData = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const BotAPI_1 = require("../../BotAPI");
const interface_1 = require("../../interface");
// 占比变化数据
const getThresholdRatioItems = () => {
    return [
        { title: "0.25%", value: "0.0025", isHighlight: false },
        { title: "0.5%", value: "0.005", isHighlight: false },
        { title: "0.75%", value: "0.0075", isHighlight: false },
        { title: "1%", value: "0.01", isHighlight: false },
        { title: "2%", value: "0.02", isHighlight: false },
        { title: "3%", value: "0.03", isHighlight: false },
        { title: "4%", value: "0.04", isHighlight: false },
        { title: "5%", value: "0.05", isHighlight: false },
    ];
};
// 动量轮动周期、定时平衡数据
const getMomentumPeriodItems = ($st) => {
    const m15 = `15${$st("strateg_Min")}`;
    const hour1 = `1${$st("strateg_Hour")}`;
    const hour4 = `4${$st("strateg_Hour")}`;
    const hour6 = `6${$st("strateg_Hour")}`;
    const hour8 = `8${$st("strateg_Hour")}`;
    const hour12 = `12${$st("strateg_Hour")}`;
    const day1 = `1${$st("grid_order_lasting_day")}`;
    const day7 = `7${$st("grid_order_lasting_day")}`;
    return [
        { title: m15, value: "900", isHighlight: false },
        { title: hour1, value: "3600", isHighlight: false },
        { title: hour4, value: "14400", isHighlight: false },
        { title: hour6, value: "21600", isHighlight: false },
        { title: hour8, value: "28800", isHighlight: false },
        { title: hour12, value: "43200", isHighlight: false },
        { title: day1, value: "86400", isHighlight: false },
        { title: day7, value: "604800", isHighlight: false },
    ];
};
// 动量轮动周期、定时平衡展示数据，兼容老版本时间
const getMomentumPeriodDisplayItems = ($st) => {
    const m5 = `5${$st("strateg_Min")}`;
    return [{ title: m5, value: "300", isHighlight: false }, ...getMomentumPeriodItems($st)];
};
// 动量轮动收益率数据
const getMomentumThresholdRorItems = () => {
    return [
        { title: "1%", value: "0.01", isHighlight: false },
        { title: "3%", value: "0.03", isHighlight: false },
        { title: "5%", value: "0.05", isHighlight: false },
        { title: "10%", value: "0.1", isHighlight: false },
        { title: "15%", value: "0.15", isHighlight: false },
        { title: "20%", value: "0.2", isHighlight: false },
        { title: "25%", value: "0.25", isHighlight: false },
        { title: "30%", value: "0.3", isHighlight: false },
    ];
};
// 获取展示单条
const getSRAdvancedSettingSheetItemDisplay = (currentItemValue, items) => {
    return items.find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value));
};
// 生成带高亮数据
const generateHighlightItems = (currentItemValue, items) => {
    return items.map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 动量轮动收益率数据展示
const getSheetMomentumThresholdRorDisplay = (currentItemValue) => {
    if (currentItemValue === undefined) {
        return undefined;
    }
    return (getMomentumThresholdRorItems().find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value)) || {
        title: trade_utils_lib_1.NumberCommonUtils.toPercent(Number(currentItemValue) * 100, false, true),
        value: `${currentItemValue}`,
        isHighlight: false,
    });
};
// 动量轮动收益率数据 生成带高亮数据
const generateHighlightMomentumThresholdRorItems = (currentItemValue) => {
    return getMomentumThresholdRorItems().map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 动量轮动周期、定时平衡展示数据展示
const getSheetMomentumPeriodDisplay = (currentItemValue, $st) => {
    return getMomentumPeriodDisplayItems($st).find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value));
};
// 动量轮动收益率数据 生成带高亮数据
const generateHighlightMomentumPeriodItems = (currentItemValue, $st) => {
    return getMomentumPeriodItems($st).map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 占比变化数据展示
const getSheetThresholdRatioDisplay = (currentItemValue) => {
    if (currentItemValue === undefined) {
        return undefined;
    }
    return (getThresholdRatioItems().find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value)) || {
        title: trade_utils_lib_1.NumberCommonUtils.toPercent(Number(currentItemValue) * 100, false, true),
        value: `${currentItemValue}`,
        isHighlight: false,
    });
};
// 占比变化数据 生成带高亮数据
const generateHighlightThresholdRatioItems = (currentItemValue) => {
    return getThresholdRatioItems().map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
/** 根据订单中币的滑点值得到滑点设置 */
const getSlippageSettingsByCoins = ({ coins = [], }) => {
    var _a;
    const vals = (_a = coins.map((item) => new trade_utils_lib_1.SafeDecimal(item.slippage).toNumber())) !== null && _a !== void 0 ? _a : [];
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // 值相同, 为手动设置
    const type = max > min ? interface_1.SlippageType.AI : interface_1.SlippageType.MANUAL;
    return {
        min,
        max,
        manualValue: type === interface_1.SlippageType.MANUAL ? min : undefined,
        type,
        enable: max > 0,
    };
};
/** 根据币的滑点值得到要显示内容 */
const getSlippageDisplayValueByCoins = ({ $st, $num, coins = [], }) => {
    const { type, min, max, manualValue, enable } = getSlippageSettingsByCoins({
        coins: coins.map((item) => ({ slippage: item.slippage })),
    });
    // 关闭AI滑点
    if (!enable) {
        return $st("fm_staking_disabled");
    }
    if (type === interface_1.SlippageType.MANUAL) {
        return `${$num(manualValue, { style: "percent", sign: "never", precision: 4 })}`;
    }
    // AI推荐
    return `${$num(min, { style: "percent", sign: "never", precision: 4 })} ~ ${$num(max, {
        style: "percent",
        sign: "never",
        precision: 4,
    })}(${$st("trading_bot_advanced_slippage_ai")})`;
};
const DEFAULT_AI_VALUE = 0.001; // 未获取到推荐值时的默认值
/**
 * 根据滑点配置和推荐值获取滑点显示值
 *
 * @param settings 滑点配置
 * @param recommendValue 推荐滑点值
 * @returns 滑点显示值
 */
const getSlippageDisplayValueBySettings = ({ $st, $num, settings, recommendValue, symbols, }) => {
    if (!settings.enable) {
        return {
            isAI: false,
            display: $st("fm_staking_disabled"),
        };
    }
    // 手动设置
    if (settings.type === interface_1.SlippageType.MANUAL) {
        return {
            isAI: false,
            display: settings.manualValue ? $num(settings.manualValue, { style: "percent", sign: "never" }) : "--",
        };
    }
    if (symbols.length === 0) {
        return {
            isAI: false,
            display: "--",
        };
    }
    // AI推荐
    if (!recommendValue) {
        return {
            isAI: false,
            display: $num(DEFAULT_AI_VALUE, { style: "percent", sign: "never" }),
        };
    }
    if (recommendValue.length === 0) {
        return {
            isAI: false,
            display: $num(DEFAULT_AI_VALUE, { style: "percent", sign: "never" }),
        };
    }
    const values = recommendValue.map((item) => new trade_utils_lib_1.SafeDecimal(item.slippage).toNumber());
    const min = Math.min(...values);
    const max = Math.max(...values);
    return {
        min,
        max,
        isAI: true,
        display: $st("trading_bot_sr_slippage_value_display", {
            min: new trade_utils_lib_1.SafeDecimal(min).mul(100).toString(),
            max: new trade_utils_lib_1.SafeDecimal(max).mul(100).toString(),
        }),
    };
};
// 根据滑点配置和推荐值获取每个币的滑点值
const getSymbolSlippages = ({ settings, recommendValue, symbols = [], }) => {
    const manualValue = settings.manualValue ? new trade_utils_lib_1.SafeDecimal(settings.manualValue).toString() : "0";
    const baseSlippageMap = new Map();
    if (recommendValue) {
        recommendValue.forEach((item) => {
            baseSlippageMap.set(item.base, item.slippage);
        });
    }
    return symbols.map((item) => {
        var _a;
        let slippage = "0";
        if (settings.enable) {
            const aiValue = (_a = baseSlippageMap.get(item.base)) !== null && _a !== void 0 ? _a : "0.001";
            slippage = settings.type === interface_1.SlippageType.AI ? aiValue : manualValue;
        }
        return {
            base: item.base,
            quote: item.quote,
            slippage,
        };
    });
};
const useSlippageSettings = ({ tradeAPI, aiRecommendQuery, settings, $st, $num, onGetAIRecommendValue, onSlippageValueChange, }) => {
    const [recommendValue, setRecommendValue] = (0, react_1.useState)(null);
    const preQueryRef = (0, react_1.useRef)({ portfolio: [] });
    const [loading, setLoading] = (0, react_1.useState)(false);
    const settingsRef = (0, react_1.useRef)(settings);
    settingsRef.current = settings;
    (0, react_1.useEffect)(() => {
        onSlippageValueChange === null || onSlippageValueChange === void 0 ? void 0 : onSlippageValueChange({
            value: getSymbolSlippages({
                settings,
                recommendValue,
                symbols: aiRecommendQuery.portfolio,
            }),
            display: getSlippageDisplayValueBySettings({ $st, $num, settings, recommendValue, symbols: aiRecommendQuery.portfolio })
                .display,
        });
    }, [aiRecommendQuery, settings, recommendValue, onSlippageValueChange, $st, $num]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!tradeAPI)
            return;
        if (!settings.enable || settings.type === interface_1.SlippageType.MANUAL) {
            return;
        }
        const preBases = (_a = preQueryRef.current.portfolio) === null || _a === void 0 ? void 0 : _a.map((item) => `${item.base}-${item.side}`).sort();
        const nextBases = aiRecommendQuery.portfolio.map((item) => `${item.base}-${item.side}`).sort();
        preQueryRef.current = aiRecommendQuery;
        if ((preBases === null || preBases === void 0 ? void 0 : preBases.join(",")) === nextBases.join(",")) {
            return;
        }
        if (aiRecommendQuery.portfolio.length === 0) {
            setRecommendValue(null);
            return;
        }
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, BotAPI_1.srRecommendSlippage)(aiRecommendQuery), { maxRetryCount: 1 }).subscribe({
            next(data) {
                var _a;
                const value = (_a = data.portfolio) !== null && _a !== void 0 ? _a : [];
                setRecommendValue(value);
                onGetAIRecommendValue === null || onGetAIRecommendValue === void 0 ? void 0 : onGetAIRecommendValue({
                    recommendValue: value,
                    symbolSlippages: getSymbolSlippages({
                        settings: { type: interface_1.SlippageType.AI, enable: true },
                        recommendValue: value,
                        symbols: aiRecommendQuery.portfolio,
                    }),
                    display: getSlippageDisplayValueBySettings({
                        $st,
                        $num,
                        settings,
                        recommendValue: value,
                        symbols: aiRecommendQuery.portfolio,
                    }).display,
                });
                setLoading(false);
            },
            error(err) {
                setLoading(false);
                setRecommendValue(null);
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aiRecommendQuery, settings, tradeAPI]);
    const { display, symbolSlippages } = (0, react_1.useMemo)(() => {
        const display = getSlippageDisplayValueBySettings({
            $st,
            $num,
            settings,
            recommendValue,
            symbols: aiRecommendQuery.portfolio,
        }).display;
        return {
            display,
            symbolSlippages: getSymbolSlippages({ settings, recommendValue, symbols: aiRecommendQuery.portfolio }),
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings, recommendValue, aiRecommendQuery.portfolio]);
    return {
        recommendValue,
        display,
        loading,
        symbolSlippages,
        getSymbolSlippages: () => getSymbolSlippages({ settings: settingsRef.current, recommendValue, symbols: aiRecommendQuery.portfolio }),
    };
};
exports.SRAdvancedSettingData = {
    getThresholdRatioItems,
    getMomentumPeriodItems,
    getMomentumPeriodDisplayItems,
    getMomentumThresholdRorItems,
    getSRAdvancedSettingSheetItemDisplay,
    generateHighlightItems,
    getSheetMomentumThresholdRorDisplay,
    generateHighlightMomentumThresholdRorItems,
    getSheetMomentumPeriodDisplay,
    generateHighlightMomentumPeriodItems,
    getSheetThresholdRatioDisplay,
    generateHighlightThresholdRatioItems,
    useSlippageSettings,
    getSlippageDisplayValueByCoins,
    getSlippageSettingsByCoins,
    getSlippageDisplayValueBySettings,
};
